import { ReactNode } from 'react';
import closeButton from 'public/static/images/close-button.png';
import { screen } from 'components/styles/variables';
import { DialogNames } from 'redux-implementations/dialog';
import useDialog from 'lib/hooks/useDialog';
import useLockedScreen from 'lib/hooks/useLockedScreen';
import useModalExiting from 'lib/hooks/useModalExiting';

interface Props {
  name: DialogNames;
  children: ReactNode;
  className?: string;
}

export default function Container({ name, children, className = '' }: Props): JSX.Element | null {
  const { isShown, close } = useDialog(name);

  const dialogRef = useModalExiting(close);

  useLockedScreen(isShown);

  if (!isShown) {
    return null;
  }

  return (
    <div className="dialog-container">
      <div className="overlay" />
      <div className="main" data-testid="outside">
        <div ref={dialogRef} className={`dialog ${className}`}>
          <button className="close" onClick={close} />
          {children}
        </div>
      </div>
      <style jsx>
        {`
          .dialog-container {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 9999;
          }

          .overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: black;
            opacity: 0.5;
          }

          .main {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 10000;
          }

          .dialog {
            user-select: none;
            background-color: white;
            position: relative;
            font-size: 18px;
            width: 100%;
            height: 100%;
            border-radius: 0;
          }

          @media (min-width: ${screen.smMin}) {
            .dialog {
              width: 435px;
              height: auto;
              border-radius: 5px;
            }
          }

          .close {
            position: absolute;
            right: 0;
            top: 0;
            height: 60px;
            width: 60px;
            border: 0;
            padding: 0;
            cursor: pointer;
            background: url('${closeButton}') no-repeat;
            background-size: 15px 15px;
            background-position: 27px 22px;
            z-index: 120;
            user-select: none;
          }
        `}
      </style>
    </div>
  );
}
